module.exports = "<div class=\"<%= thumbInfo %>\">\n    <ng-transclude></ng-transclude>\n</div>"